import './FamilySidebar.scss';

import { FamilyTreeDiagram } from '@pages/fvt/components/FamilyTreeDiagram';

import { HypoparaAssociationCard } from './HypoparaAssociationCard';

export const FamilySidebar = () => (
  <aside className='fvt-family-sidebar' aria-label='Family testing guidance'>
    <FamilyTreeDiagram />
    <HypoparaAssociationCard />
  </aside>
);
